interface Location {
  name: string;
  business_name: string;
  address: string;
  city: string;
  region: string;
  country: string;
  postal_code: string;
  telephone: string;
  telephones: string;
  placeId: string;
  latitude: number;
  longitude: number;
}

class RentalMap {
  public constructor(elMap: HTMLElement, elAutocomplete: HTMLInputElement, locations: Location[]) {
    this.init(elMap, elAutocomplete, locations);
  }

  /**
   *
   */
  private async init(elMap: HTMLElement, elAutocomplete: HTMLInputElement, locations: Location[]): Promise<void> {
    const { Map, InfoWindow } = await (google.maps.importLibrary('maps') as Promise<google.maps.MapsLibrary>);
    const { AdvancedMarkerElement, PinElement } = await (google.maps.importLibrary('marker') as Promise<google.maps.MarkerLibrary>);

    // instantiate the map
    const map = new Map(elMap, {
      zoom: 3,
      center: { lat: 38.54060682091429, lng: -35.607759972079755 },
      mapId: 'rental-map',
    });

    // create a single info window to be shared by all markers
    const infoWindow = new InfoWindow();

    // create markers for each location
    for (let location of locations) {
      const pin = new PinElement({
        scale: 1.5,
        background: '#f46c15',
        borderColor: '#f46c15',
        glyphColor: 'orange',
      });

      const marker = new AdvancedMarkerElement({
        position: new google.maps.LatLng({ lat: location.latitude, lng: location.longitude }),
        map,
        title: `
          <b>${location.business_name}</b><br>
          <i>${location.address}, ${location.city}, ${location.region} ${location.postal_code}</i><br><br>
          <p><b>Rental Sales</b> - 1.888.508.3226<br><b>Rental Support</b> - 1.833.661.LINK<br><b>Office</b> - ${location.telephone}</p>
          <p><b>Email</b> - <a href= "mailto: sales@superheat.com">sales@superheat.com</a></p>
          <a href="https://www.google.com/maps/place/?q=place_id:${location.placeId}" target="_blank">View on Google Maps</a>
        `,
        content: pin.element,
        gmpClickable: true,
      });

      marker.addListener('click', () => {
        infoWindow.close();
        infoWindow.setContent(marker.title);
        infoWindow.open(marker.map, marker);
      });
    }

    // Create the autocomplete object, restricting the search predictions to geographical location types.
    const autocomplete = new google.maps.places.Autocomplete(
      elAutocomplete,
      { types: ['geocode'], fields: ['place_id', 'geometry', 'formatted_address'] }
    );

    // When the user selects an address from the drop-down
    autocomplete.addListener('place_changed', () => {
      // identify the autocomplete's location and recenter the map on that location
      const place = autocomplete.getPlace();
      if (place.geometry?.location) {
        map.panTo(place.geometry.location);
      }
      map.setZoom(6);
    });
  }
}

(() => {
  const onReady = () => {
    try {
      const elMap = document.querySelector('.rental-map__map-container');
      if (!(elMap instanceof HTMLElement)) {
        throw new Error('Could not identify target map element.');
      }

      const elLocationsData = document.querySelector('.rental-map__locations');
      const locations = JSON.parse(elLocationsData?.textContent ?? '[]') as Location[];

      const elAutocomplete = document.querySelector('.rental-map__autocomplete');
      if (!(elAutocomplete instanceof HTMLInputElement)) {
        throw new Error('Could not identify autocomplete search element.');
      }

      new RentalMap(elMap, elAutocomplete, locations);
    } catch {
      // fail silently
    }
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', onReady) : onReady();
})();
